import { ConnectedDashboardMetrics } from '../ConnectedDashboardMetrics';

export function MonitoringDashboards() {
  return (
    <ConnectedDashboardMetrics
      dashboards={['onlinecp', 'onlineport', 'evcharge', 'problems']}
    />
  );
}
